import type { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { createStyleHelper } from '../../../shared/utils/class-names';

import styles from './inactive-bonus-heading.module.scss';

const style = createStyleHelper(styles, 'inactive-bonus-heading');

export const InactiveBonusHeading: FunctionComponent = () => {
    return (
        <div className={style()}>
            <div className={style('image-space')}></div>
            <div className={style('description')}>
                <FormattedMessage id="account.bonuses.description" defaultMessage="Description" />
            </div>
            <div className={style('amount')}>
                <FormattedMessage id="account.bonuses.amount" defaultMessage="Amount" />
            </div>
            <div className={style('status')}>
                <FormattedMessage id="account.bonuses.status" defaultMessage="Status" />
            </div>
        </div>
    );
};
